<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <div v-if="$store.getters.enableFrontEndPlugin">
        <micro-app
          name="child-operation-date-query-bookingverify"
          :url="$store.getters.frontEndPluginUrl+'/operationDateQuery'"
          router-mode="pure"
          destroy
          @datachange="operationDateQueryDataChange"
        />
      </div>
      <search-item
        config-module="110"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <el-button no="1" :disabled="!selectedJob || total <= 0" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <el-button no="2" :disabled="!(btn.btnAdd)" type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
          <el-button no="3" :disabled="!(btn.btnCopy && selectedJob)" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
          <el-dropdown
            v-if="isHc"
            no="priceAuditHandle"
            split-button
            type="primary"
            :disabled="!selectedJob || total <= 0"
            style="margin:0 5px"
            @click="priceAuditHandle"
            @command="p=>{priceAuditCommand=p;priceAuditHandle()}"
          >
            {{ priceAuditCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('CargoMsg.Cargo_preportAudit')">{{
                $t('CargoMsg.Cargo_preportAudit')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('CargoMsg.Cargo_TrunkLineAudit')">{{
                $t('CargoMsg.Cargo_TrunkLineAudit')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_TailEndAudit')"
              >{{ $t('CargoMsg.Cargo_TailEndAudit') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--审核通过-->
          <el-button v-show="$checkPermission(['button_fmVerify_accept'])" no="4" type="primary" @click="acceptHandler(0)">{{ $t('SeaExport.PassAudit') }}</el-button>
          <!--拒绝-->
          <el-button v-show="$checkPermission(['button_fmVerify_reject'])" no="5" type="primary" @click="rejectHandler(0)">{{ $t('SeaExport.Refuse') }}</el-button>
          <!--复核通过-->
          <el-button v-show="$checkPermission(['button_fmVerify_reviewThrough']) && btn.pretrialReviewConfig" no="6" type="primary" @click="btVerifyReviewThroughHandler(0)">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
          <!--复核拒绝-->
          <el-button v-show="$checkPermission(['button_fmVerify_reviewRefusal']) && btn.pretrialReviewConfig" no="7" :disabled="!(btn.btVerifyReviewRefusal && btn.pretrialReviewRefusalRole)" type="primary" @click="btVerifyReviewRefusalHandler(0)">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
          <!--复制舱位-->
          <el-button v-show="$checkPermission(['button_fmVerify_cloneCabin'])" no="8" :disabled="!(btn.cloneCabin && btn.acceptRole)" type="primary" @click="cloneCabinHandler">{{ $t('SeaExport.CloneCabinBerth') }}</el-button>
          <!--舱位回填-->
          <el-button v-show="$checkPermission(['button_fmVerify_cabinBackFill'])" no="9" :disabled="!(btn.cabinBackFill && btn.rejectRole)" type="primary" @click="cabinBackFillHandler">{{ $t('SeaExport.BackFillCabinBerth') }}</el-button>
          <!--编辑-->
          <el-button v-show="$checkPermission(['button_fmVerify_edit'])" no="10" :disabled="!(btn.acceptRole)" type="success" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
          <!--生成业务-->
          <el-button v-show="$checkPermission(['button_fmVerify_generateBusiness'])" no="11" :disabled="!(btn.generateBusiness && btn.rejectRole)" type="primary" @click="generateBusinessHandler">{{ $t('SeaExport.GenerateBusiness') }}</el-button>
          <!--退舱-->
          <el-button v-show="$checkPermission(['button_fmVerify_returnCabin'])" no="12" :disabled="!(btn.returnCabin && btn.rejectRole)" type="primary" @click="returnCabinHandler">{{ $t('SeaExport.ReturnCabin') }}</el-button>
          <!--退舱-->
          <el-button v-show="$checkPermission(['button_fmVerify_batchVessel'])" no="13" type="primary" @click="batchVesselHandler">{{ $t('SeaExport.BatchVessel') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="130100"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="110001"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="toQuery()"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!--    订舱审核-通过   -->
    <op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :batch-pass-audit="opVerifyFrameDialog.batchPassAudit"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
      :job-list="opVerifyFrameDialog.jobList"
    />
    <!--    订舱审核-拒绝   -->
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :job-list="rejectWindow.jobList"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!--信控验证弹框-->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!--    舱位回填   -->
    <cabin-back-fill-window
      v-if="cabinBackFillWindow.visible"
      :visible.sync="cabinBackFillWindow.visible"
      :job-model="cabinBackFillWindow.job || {}"
      :context="context"
      @reloadFunc="reloadFunc"
    />
    <!--舱位复制-->
    <cabin-duplicate-dialog
      :visible="cabinDuplicateForm.dialogVisible"
      :job="selectedJob"
      :reload-func="null"
      @submit="cabinDuplicateSubmit"
      @close="cabinDuplicateForm.dialogVisible=false"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--编辑-->
    <edit-dialog :visible.sync="editDialog.visible" :job-model="editDialog.job" :context="context" @reloadFunc="reloadFunc" />
    <!-- 批量转船弹窗 -->
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      :visible.sync="transshipDialog.visible"
      :title="$t('SeaExport.BatchVessel')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.Vessel')">
          <div style="display: flex">
            <cargo-advance-select
              v-show="!transshipDialog.isDBFlag"
              :disabled="clearCheckBox.vessel"
              no="14"
              style="width:250px;"
              filterable
              options-width="195px;"
              :select-type="selectTypeNames.basic_data_Vessel"
              :default-value="transshipDialog.txtVessel"
              :callback-params="{key:'txtVessel'}"
              @parentCallBack="onVesselSelectionChange"
            />
            <el-input v-show="transshipDialog.isDBFlag" v-model="transshipDialog.txtVessel_1" :disabled="clearCheckBox.vessel" no="15" style="width:250px;" />
            <el-checkbox v-model="clearCheckBox.vessel" style="margin-left: 10px" @change="clearCheckBoxChange('vessel')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Voyage')">
          <div style="display: flex">
            <el-select v-show="!transshipDialog._isVoyages" v-model="transshipDialog.txtVoyage" :disabled="clearCheckBox.voyage" style="width:250px;">
              <el-option
                v-for="(item) in transshipDialog.voyages"
                :key="item.voyageId"
                :label="item.voyageNo"
                :value="item.voyageNo"
              />
            </el-select>
            <el-input v-show="transshipDialog._isVoyages" no="16" :disabled="clearCheckBox.vessel" :value="(transshipDialog._fmVerify && transshipDialog.txtVoyage_1.indexOf('V.') < 0) ? ('V.' + transshipDialog.txtVoyage_1) : transshipDialog.txtVoyage_1" style="width:250px;" @input="val=>{transshipDialog.txtVoyage_1=val}" />
            <el-checkbox v-model="clearCheckBox.voyage" style="margin-left: 10px" @change="clearCheckBoxChange('voyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>

        </el-form-item>
        <el-form-item label="IMO">
          <div style="display: flex">
            <el-input v-model="transshipDialog.txtVesselIMO" :disabled="clearCheckBox.imo" no="17" style="width:250px;" />
            <el-checkbox v-model="clearCheckBox.imo" style="margin-left: 10px" @change="clearCheckBoxChange('imo')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ShippingCompany')">
          <div style="display: flex">
            <cargo-advance-select
              no="18"
              filterable
              :disabled="clearCheckBox.carrierId"
              style="width:250px;"
              options-width="200px;"
              :method-params="{seaCmp:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="transshipDialog.txtCarrierId||''"
              @parentCallBack="p=>transshipDialog.txtCarrierId=p.cmpIdx"
            />
            <el-checkbox v-model="clearCheckBox.carrierId" style="margin-left: 10px" @change="clearCheckBoxChange('carrierId')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.DateOfDeparture')">
          <el-date-picker v-model="transshipDialog.dfETD" no="19" type="date" value-format="yyyy-MM-dd" style="width:212px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.BookingAgent')">
          <div style="display: flex">
            <cargo-advance-select
              no="20"
              filterable
              :disabled="clearCheckBox.bookingAgent"
              style="width:250px;"
              options-width="200px;"
              :method-params="{bookingAgent:true}"
              :select-type="selectTypeNames.basic_data_Company"
              :default-value="transshipDialog.txtBookingAgent||''"
              @parentCallBack="p=>transshipDialog.txtBookingAgent=p.cmpIdx"
            />
            <el-checkbox v-model="clearCheckBox.bookingAgent" style="margin-left: 10px" @change="clearCheckBoxChange('bookingAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="21" type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="22" @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :sea-job="cooperationVerifyDialog.job"
      :config="cooperationVerifyDialog.config"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble, stringToBool } from '@/utils/commonUtil'
import jobDetailIcon from '@/assets/job-detail.png'
import { isArray } from '@/utils/validate'
import {
  queryFmVerify,
  advancedQueryForVerify,
  cloneCabin,
  approved,
  preVerifyReject,
  batchTransship, getVoyagesByVesselId, batchPreVerifyReject
} from '@/api/seaExport/seaExportJob'
import { batchCheckJobsCredit, updateInquiryJobState } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import CargoFormDialog from '@/components/Cargo/Common/CargoFormDialog'
import CabinDuplicateDialog from '@/views/cargo/v0/SeaExport/components/verify/CabinDuplicateDialog'
import OpVerifyFrameDialog from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameDialog'
import ConfirmDialogWindow from '@/views/cargo/v0/SeaExport/components/verify/ConfirmDialogWindow'
import OpVerifyFrameReject from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject'
import CabinBackFillWindow from '@/views/cargo/v0/SeaExport/components/verify/CabinBackFillWindow'
import EditDialog from '@/views/cargo/v0/SeaExport/components/verify/EditDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { getCacheListByKey, getFilterCacheList, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import microApp from '@micro-zoe/micro-app'
import $store from '@/store'

export default {
  name: 'VerifyTreeGrid',
  components: {
    cargoAgGridWrapper,
    EditDialog,
    CabinBackFillWindow,
    CabinDuplicateDialog,
    OpVerifyFrameDialog,
    OpVerifyFrameReject,
    ConfirmDialogWindow,
    CargoFormDialog,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    BatchCheckingWindow,
    cooperationVerifyDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      ticketsMustBeVoted: false, // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      editVessel: '', // //订舱性质
      salesCanSeeBookingAgent: false,
      isEditing: false,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      pageCount: 0,
      // customSearchItems: [], // 自定义高级查询项
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        // onSortChanged: (event) => {
        //   // this.$logger.log('onSortChanged-event', event)
        //   if (this.rowDataBeforeSort && this.rowDataBeforeSort.length !== this.rowData.length) {
        //     this.rowDataBeforeSort = this.rowData
        //   }
        //   if (!event.api.getSortModel().length) {
        //     this.rowData = this.rowDataBeforeSort
        //     this.rowDataBeforeSort = []
        //   } else {
        //     this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
        //   }
        // },
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          this.selectedRowCount = event.api.getSelectedRows().length
        }
      },
      selectedRowCount: 0,
      isTrunkLineApprove: false,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.dataType && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.dataType && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnAdds: [],
      rowData: [],
      gridApi: null,
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      documentManage: new DocumentManage(),
      transshipDialog: {
        visible: false,
        _fmVerify: false,
        _isVoyages: true,
        jobKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        txtVessel: '',
        txtVessel_1: '',
        txtVoyage: '',
        txtVoyage_1: '',
        txtVesselIMO: '',
        txtCarrierId: '',
        dfETD: '',
        txtBookingAgent: '',
        voyages: '',
        transship: {}
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      priceAuditCommand: this.$t('CargoMsg.Cargo_preportAudit'),
      blModeList: [],
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      creditRestrictionForBooking: 0, // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      reqInputCharge: false, // 是否必录费用
      isBookingFeeMandatoryAppliedGlobally: false, // 订舱费用必填是否全模块应用
      isPretrialReview: false,
      btn: {
        acceptRole: true, // 新增
        rejectRole: true, // 复制
        pretrialReviewThroughRole: true, // 新增
        pretrialReviewRefusalRole: true, // 复制
        pretrialReviewConfig: false, //
        // 按钮权限
        btnAdd: true, // 新增
        btnCopy: true, // 复制
        btAccept: true, // 审核通过
        btReject: true, // 拒绝
        btVerifyReviewThrough: true, // 复核通过
        btVerifyReviewRefusal: true, // 复核拒绝
        cloneCabin: true, // 舱位复制
        cabinBackFill: true, // 舱位回填
        edit: true, // 编辑
        generateBusiness: false, // 生成业务
        returnCabin: false // 退舱
      },
      lob: 'SE',
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: null,
        jobList: [],
        type: 0 // 0  =  列表审核通过 1  =  在详情页面审核通过
      },
      cabinBackFillWindow: {
        visible: false,
        job: null
      },
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        batchPassAudit: false,
        job: null,
        jobList: [],
        result: null, // 审核通过界面所填写的值
        verifyType: 1, // 订舱预审-审核通过类型1、save2 2、approved2 3、batchUpdateJobs 4、batchApproved
        type: 0, // 0  =  列表审核通过 1  =  在详情页面审核通过
        submitCallBack: null
      },
      batchJobList: [], // 批量审核通过的业务列表
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      cabinDuplicateForm: { // 舱位复制使用
        dialogVisible: false
      },
      editDialog: { // 编辑
        visible: false,
        job: new SeaExportJob().fillDefaultValue().getData()
      },
      appendQuery: false, // 追加查询
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true,
        job: null,
        config: null
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      isZY: false,
      isHc: false,
      defaultSearchItems: [],
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      clearCheckBox: {
        vessel: false,
        voyage: false,
        imo: false,
        carrierId: false,
        bookingAgent: false
      },
      operationDateQuery: { // 操作日期查询条件、显示列
        viewSource: 'BookingVerify',
        searchItem: false, // 查询条件
        columnItem: false // 显示列
      },
      operationDateQuerySearch: false,
      operationDateQueryColumn: false
    }
  },
  computed: {
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return cache.config ? Number(cache.config.get('approveCooperationBusiness')) === 1 : false
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.$store.state.tagsView.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    columnDefs() {
      let result = [
        // 显示列
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          colId: 'customJobType',
          valueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name')
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Grade'),
          field: 'secondaryCustomJobType',
          colId: 'secondaryCustomJobType',
          valueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.secondaryCustomJobType, 'name')
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          enableRowGroup: true,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 170
        }, {
          headerName: this.$t('SeaExport.TransitPort'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 170
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.data.crossTenantHistoryState)
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          width: 150,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlineArea'),
          field: 'regionName',
          colId: 'regionName',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ServiceCode'),
          field: 'vesselLineCode',
          colId: 'vesselLineCode',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfArrival'),
          field: 'eta',
          colId: 'eta',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.CYCutOffDate2'),
          field: 'customCutoff',
          colId: 'customCutoff',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DocCutOffDate'),
          field: 'fileCutoff',
          colId: 'fileCutoff',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'jobNo5',
          colId: 'jobNo5',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.sales), 'chineseName')
            }
            return ''
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.data.carrierId), 'chineseName')
            }
            return ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DestinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'englishName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp', enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.overseaOp), 'chineseName')
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PreverifyStatus'),
          field: 'preverifyState',
          colId: 'preverifyState',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.getPreverifyStateCN(Number(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessStatus'),
          field: 'jobState',
          colId: 'jobState',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.getJobStateForBlock(params.data)
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
          field: 'prePortPlanner',
          colId: 'prePortPlanner',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IncludeSoc'),
          field: 'containerSoc',
          width: 100,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', stringToBool(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
          field: 'lastMilePlanner',
          colId: 'lastMilePlanner',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_preportAuditStatus'),
          field: 'prePortApproveStatus',
          colId: 'prePortApproveStatus',
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TrunkLineAuditStatus'),
          field: 'trunkLineApproveStatus',
          colId: 'trunkLineApproveStatus',
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TailEndAuditStatus'),
          field: 'lastMileApproveStatus',
          colId: 'lastMileApproveStatus',
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Auditor'),
          field: 'preverifier',
          colId: 'preverifier',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.preverifyDate'),
          field: 'preverifyDate',
          colId: 'preverifyDate',
          enableRowGroup: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.CabinState'),
          field: 'cabinState',
          colId: 'cabinState',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return SeaExportConstants.getCabinStateName(Number(params.data.cabinState))
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('Partners.Refuser'),
          colId: 'refuser',
          field: 'refuser',
          hide: true,
          enableRowGroup: true,
          width: 180,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.refuser, 'chineseName') : ''
          },
          valueGetter: (params) => {
            if (params.data) {
              return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.refuser), 'chineseName') : ''
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'bookingRefuseNote',
          field: 'bookingRefuseNote',
          hide: true,
          enableRowGroup: true,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
          },
          valueGetter: (params) => {
            if (params.data) {
              return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnModule'),
          field: 'returnType',
          colId: 'returnType',
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          },
          valueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnReason'),
          field: 'returnRemark',
          colId: 'returnRemark',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('Partners.RefuseDate'),
          colId: 'refuseDate',
          field: 'refuseDate',
          enableRowGroup: true,
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
          },
          valueGetter: params => {
            if (params.data) {
              return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.BookingNo'),
          field: 'bookingNo',
          colId: 'bookingNo',
          width: 150,
          hide: true
        }
      ]
      if (this.bookingAgentVisible) {
        result.push({
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        })
      }
      result.push({
        headerName: this.$t('SeaExport.Vessel'),
        field: 'vessel',
        colId: 'vessel',
        enableRowGroup: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Voyage'),
        field: 'voyageFlight',
        colId: 'voyageFlight',
        enableRowGroup: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SoNo'),
        field: 'soNo',
        colId: 'soNo',
        hide: true,
        enableRowGroup: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContainerDescription'),
        field: 'containerDesc',
        colId: 'containerDesc',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.containerDescLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MBLTransportationClause'),
        field: 'freightTerm',
        colId: 'freightTerm',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLTransportationClause'),
        field: 'freightTermHBL',
        colId: 'freightTermHBL',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MasterBLFreightTerm'),
        field: 'paymentTermMBL',
        colId: 'paymentTermMBL',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermMBL)
          }
          return ''
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.HBLFreightClause'),
        field: 'paymentTermHBL',
        colId: 'paymentTermHBL',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermHBL)
          }
          return ''
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.BusinessReferenceNo'),
        field: 'customerRefNo',
        colId: 'customerRefNo',
        enableRowGroup: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
        field: 'quantityContract',
        colId: 'quantityContract',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.CommissionedGrossWeight'),
        field: 'weightContract',
        colId: 'weightContract',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.CommissionedVolume'),
        field: 'cubageContract',
        colId: 'cubageContract',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.ActualQuantity'),
        field: 'quantityActual',
        colId: 'quantityActual',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.ActualWeight'),
        field: 'weightActual',
        colId: 'weightActual',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.ActualVolume'),
        field: 'cubageActual',
        colId: 'cubageActual',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150,
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
        field: 'cargoChineseName',
        colId: 'cargoChineseName',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
        field: 'cargoEnglishName',
        colId: 'cargoEnglishName',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.quotationNum'),
        colId: 'quotationNo',
        field: 'quotationNo',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.AirlinePerson2'),
        colId: 'planner',
        field: 'planner',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.planner), 'chineseName')
          }
          return ''
        },
        width: 80
      }, {
        headerName: this.$t('SeaExport.CustomerService'),
        field: 'csr',
        colId: 'csr',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.csr), 'chineseName')
          }
          return ''
        },
        width: 100
      }, {
        headerName: this.$t('SeaExport.Documents'),
        field: 'dc',
        colId: 'dc',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.dc), 'chineseName')
          }
          return ''
        },
        width: 100
      }, {
        headerName: this.$t('SeaExport.Creator'),
        field: 'createdBy',
        enableRowGroup: true,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.createdBy), 'chineseName')
          }
          return ''
        },
        width: 120
      }, {
        headerName: this.$t('SeaExport.ProjectName'),
        field: 'projectName',
        colId: 'projectName',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ProjectBatch'),
        field: 'projectBatch',
        colId: 'projectBatch',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_CooperateStatus'),
        colId: 'cooperateStatus',
        field: 'cooperateStatus',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.cooperateStatusLabelFunc(Number(params.value))
        },
        hide: !this.useOrderCenterMode,
        width: 100, minWidth: 100
      },
      { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180,
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180,
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('FinanceManage.charge_profitAll'), colId: 'realProfit', field: 'realProfit', width: 180,
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        },
        summaryMode: 'sum'
      }, {
        headerName: this.$t('SeaExport.Remarks'),
        field: 'remarks',
        colId: 'remarks',
        enableRowGroup: true,
        hide: true,
        width: 150
      },
      {
        headerName: this.$t('queryJob.EstimatedReviewer'),
        field: 'preverifier',
        colId: 'preVerifier',
        width: 180,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('queryJob.DateOfPreReview'),
        field: 'preverifyDate',
        colId: 'preVerifyDate',
        width: 180,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('Message.TerminalCompany'),
        colId: 'terminalCompany',
        field: 'terminalCompany',
        width: 180,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('Message.Customer_Service'),
        colId: 'csrDepartment',
        field: 'csrDepartment',
        width: 180,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('Message.Documentation_Department'),
        colId: 'dcDepartment',
        field: 'dcDepartment',
        width: 180,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.AirlineDepartment'),
        colId: 'plannerDepartment',
        field: 'plannerDepartment',
        width: 140,
        enableRowGroup: true,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_IsCabinSpace'), field: 'availableCabinSpace', width: 180, colId: 'availableCabinSpace', hide: true,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.Marks'),
        field: 'mark',
        colId: 'mark',
        enableRowGroup: true,
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CustomerOffice'),
        field: 'csrOffice',
        colId: 'csrOffice',
        enableRowGroup: true,
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.DocumentOffice'),
        field: 'dcOffice',
        colId: 'dcOffice',
        enableRowGroup: true,
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.ChannelNo'),
        field: 'channelNo',
        colId: 'channelNo',
        enableRowGroup: true,
        hide: true,
        width: 100
      }, {
        headerName: this.$t('SeaExport.TaxNature'),
        field: 'taxNature',
        colId: 'taxNature',
        cellRenderer: params => {
          return ColumnUtils.taxNatureLabelFunction(params.value)
        },
        width: 120
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
        field: 'userDefinedRoleId1',
        colId: 'userDefinedRoleId1',
        enableRowGroup: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
        field: 'userDefinedRoleId2',
        colId: 'userDefinedRoleId2',
        enableRowGroup: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
        field: 'userDefinedRoleId3',
        colId: 'userDefinedRoleId3',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
        field: 'userDefinedRoleId4',
        colId: 'userDefinedRoleId4',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
        field: 'userDefinedRoleId5',
        colId: 'userDefinedRoleId5',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
        field: 'userDefinedRoleId6',
        colId: 'userDefinedRoleId6',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
        field: 'userDefinedRoleId7',
        colId: 'userDefinedRoleId7',
        enableRowGroup: true,
        hide: true,
        width: 140,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      })
      if (this.isZY) {
        result.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(Number(params.value))
            }
          }
        )
      }
      if (this.$store.state.uiCustom.enable) {
        result = UICustomUtil.handleColumnDefs(UICustomConstants.SEA_VERIFY_BOOKING_MODULE, this.$store.getters.currentOfficeId, result)
      }
      // 操作日期
      if (this.operationDateQueryColumn) {
        result.push({
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        })
      }
      return result
    }
  },
  async created() {
    this.blModeList = await getSpecificBasicData(basicCacheKeys.basic_data_BlMode)
    await this.preloadBasicData()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeJob = node.data
            if (nodeJob.jobUuid) this.selectedJob = nodeJob
            this.updateControlsState()
          }
        })
        // this.$logger.log('===onGridCellFocused====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.jobUuid) this.selectedJob = node
      this.updateControlsState()
    },
    // 批量操作按钮权限控制
    updateControlsState() {
      const _job = this.selectedJob
      if (_job && (this.btn.acceptRole || this.btn.rejectRole)) {
        this.btn.cabinBackFill = _job.cabinState !== 5 && _job.cabinState !== 6
        this.btn.generateBusiness = this.btn.returnCabin = _job.cabinState === 4
        this.btn.btReject = _job.jobState === -1 && (_job.preverifyState !== 5 && _job.preverifyState !== 2 && _job.preverifyState !== 3)
        this.btn.btReject = this.btn.btReject || (this.isCooperate(_job.cooperateStatus) && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(_job.cooperateStatus))
      }
      if (_job && this.btn.pretrialReviewConfig) {
        // 选中的所有job，判断是否全部符合复核条件
        let btVerifyReviewThroughs = true
        const jobLists = this.readSelectedRows(false)
        for (let i = 0; i < jobLists.length; i++) {
          const seaJob = jobLists[i]
          if (!(seaJob.jobState === -1 && this.btn.pretrialReviewThroughRole && this.btn.pretrialReviewConfig && seaJob.preverifyState === 2)) {
            btVerifyReviewThroughs = false
          }
        }
        // 复核通过
        this.btn.btVerifyReviewThrough = btVerifyReviewThroughs
        // 复核拒绝
        this.btn.btVerifyReviewRefusal = _job.jobState === -1 && this.btn.pretrialReviewRefusalRole && this.btn.pretrialReviewConfig && _job.preverifyState === 2
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.init()
    },
    init() {
      this.btn.acceptRole = this.$checkPermission(['button_fmVerify_accept'])
      this.btn.rejectRole = this.$checkPermission(['button_fmVerify_reject'])
      this.btn.pretrialReviewThroughRole = this.$checkPermission(['button_fmVerify_reviewThrough'])
      this.btn.pretrialReviewRefusalRole = this.$checkPermission(['button_fmVerify_reviewRefusal'])
      this.btn.pretrialReviewConfig = parseInt(cache.config.get('PretrialReview')) === 1
      this.creditRestrictionForBooking = parseInt(cache.config.get('CreditRestrictionForBooking'))
      this.reqInputCharge = parseInt(cache.config.get('saveCharge')) === 1
      this.isBookingFeeMandatoryAppliedGlobally = Number(cache.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      this.isPretrialReview = Number(cache.config.get('PretrialReview')) === 1
      this.editVessel = Number(cache.config.get('EditVesselVoyageMode'))
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.salesCanSeeBookingAgent = Number(cache.config.get('SalesCanSeeBookingAgent')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 组装查询条件
    getCustomSearchItems() {
      let dataProvider = Array.from(SystemConstants.VERIFY_STATES)
      if (this.isPretrialReview) {
        dataProvider.push(SystemConstants.VERIFYING_REVIEW_THROUGH)
        dataProvider.push(SystemConstants.VERIFYING_REVIEW_REFUSAL)
      }
      const defaultSearchFields = []
      // 预审状态
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.PREVERIFY_STATE'
      searchField.itemLabel = 'SeaExport.PreverifyStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
      searchField.dataCacheKey = ''
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = dataProvider
      defaultSearchFields.push(searchField.formatObj2Json())

      // 箱型
      const boxTypes = SeaExportConstants.SEA_EXPORT_BOX_TYPES.map(item => {
        return { code: item.code, chineseName: item.chineseName, englishName: item.englishName }
      })

      defaultSearchFields.push(JobUtils.createSearchField(boxTypes, 'seaEq.EQSIZE', 'SeaExport.BoxModel'))

      // 箱种
      const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
      const eqTypeList = eqTypes && Array.isArray(eqTypes)
        ? eqTypes.map((eqType) => ({
          code: eqType.code,
          chineseName: eqType.code,
          englishName: eqType.name
        })) : []

      defaultSearchFields.push(JobUtils.createSearchField(eqTypeList, 'seaEq.EQTYPE', 'SeaExport.BoxSpecies'))
      // 提单方式
      dataProvider = BillReleaseType.BILL_RELEASES.map(item => {
        return { code: item.serialNumber, chineseName: item.name }
      })
      if (this.blModeList && this.blModeList.length > 0) {
        for (const blMode of this.blModeList) {
          if (blMode.blType !== 3) continue
          dataProvider.push({ code: blMode.serialNumber, chineseName: blMode.localName })
        }
      }
      // console.log('dataProvider=====', dataProvider)
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocHBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.HBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = dataProvider
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode && this.approveCooperationBusiness) {
        // 协作状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.COOPERATE_STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = Array.from(SystemConstants.COOPERATE_STATUS)
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'SeaExport.BookingAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.seaExportEnabled === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.SEA_VERIFY_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
      }
      // 操作日期
      if (this.operationDateQuerySearch) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.subType = 'range'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'job.CUSTOMS_DATE'
        searchField.itemLabel = 'SeaExport.OperationDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      return defaultSearchFields
    },
    // 查询[简单查询/高级查询]
    toQuery(workSpaceRowData) {
      if (workSpaceRowData && workSpaceRowData.length > 0) {
        this.toBackQuery(workSpaceRowData)
        return
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filterJson.conditions)
        this.filter.pageNum = 1
      }
      if (!this.filterJson.conditions) return
      this.filterJson.appendQuery = this.appendQuery
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize

      this.loading = getLoading()
      advancedQueryForVerify(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      if (AdvancedSearchOption.hasField('cargoDocHBL.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('cargoDoc.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL2).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('seaCargoDoc.SUB_DOC_TYPE2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.MBL2).formatObj2Json())
      }
      // HBL 提单状态
      if (AdvancedSearchOption.hasField('cargoDoc.CFM_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDoc.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // HBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDoc.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDoc.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // 预审
      if (!AdvancedSearchOption.hasField('job.PREVERIFY_STATE', data)) {
        data.push(new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', [0, 1, 2, 3], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        data.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
      }

      const lcOption = AdvancedSearchOption.getOption('job.localSevice', data)
      if (lcOption != null) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service != null) services.push(service)
        }
        const stuffingTypes = this.convertStuffyTypeToQuery(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.localSevice', data)) {
        AdvancedSearchOption.removeOption('job.localSevice', data)
      }
      // 如果状态追踪没有选中值则将条件移除
      if (AdvancedSearchOption.hasField('trackingInfo._multipleState_', data)) {
        const trackingInfoOption = AdvancedSearchOption.getOption('trackingInfo._multipleState_', data)
        if (trackingInfoOption) {
          const trackingInfoValue = trackingInfoOption.value.value
          if (!trackingInfoValue || (isArray(trackingInfoValue) && trackingInfoValue.length <= 0)) {
            AdvancedSearchOption.removeOption('trackingInfo._multipleState_', data)
          }
        }
      }
      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      if (!this.filter.jobNo) return
      this.$logger.log('this.filter', this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      queryFmVerify(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 返回查询
    toBackQuery(jobs) {
      const conditions = []
      if (jobs && jobs.length > 0) {
        const jobNos = Array.from(jobs, p => p.jobNo)
        conditions.push(new AdvancedSearchOption(null, 'job.JOB_NO', jobNos, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
      }
      conditions.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
      this.filterJson.conditions = conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      advancedQueryForVerify(this.filterJson).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.loading = getLoading()
      let results = res.data.list
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.total = results.length
      } else {
        this.pageCount = res.data.pages
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }
      // 对返回结果进行排序放在后端 getJobsBySort 方法
      this.rowData = results
      this.selectedJob = null
      this.selectedRowCount = 0
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    // 查看
    toLook(row) {
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        const rows = row ? [row] : this.readSelectedRows()
        const jumpRows = []
        const openSet = new Set([...this.viewJobNoSet])
        for (const item of rows) {
          if (!openSet.has(item.jobNo)) {
            jumpRows.push(item)
            openSet.add(item.jobNo)
          }
        }
        if (openSet.size > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        if (jumpRows.length === 0) {
          this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: rows[0].jobNo }})
          return
        }
        for (const item of jumpRows) {
          setTimeout(() => {
            this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: item.jobNo }, params: { rowData: [...this.rowData] }})
          }, 100)
        }
        // 切回到跳转的第一票
        setTimeout(() => {
          this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: jumpRows[0].jobNo }})
        }, 100)
      } else {
        if (!row) {
          row = this.selectedJob || this.readSelectedRows()[0]
        }
        if (this.viewJobNoSet.has(row.jobNo)) {
          this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: row.jobNo }})
        } else {
          this.$emit('look', row)
        }
      }
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 审核通过 0  =  批量审核通过 1  =  在详情页面审核通过
    acceptHandler(type) {
      this.opVerifyFrameDialog.type = type
      if (type === 0) {
        const jobLists = this.readSelectedRows()
        if (!jobLists || jobLists.length <= 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJob'))
          return
        }
        if (jobLists.length > 500) {
          this.$message.warning(this.$t('SeaExport.BookingVerifyBatch'))
          return
        }
        // 协作状态: 审核通过
        const cooperateList = []
        for (const seaJob of jobLists) {
          if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
        }
        if (cooperateList.length > 0) {
          if (cooperateList.length !== jobLists.length) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
            return
          }
          this.acceptCooperateHandler(type, cooperateList)
          return
        }
        const jobArr = []
        for (const seaJob of jobLists) {
          if (seaJob.jobState !== -1 || seaJob.preverifyState === 2 || seaJob.preverifyState === 3) {
            jobArr.push(seaJob.jobNo)
          }
          if (this.isPretrialReview && (seaJob.preverifyState === 5 || seaJob.preverifyState === 6)) {
            jobArr.push(seaJob.jobNo)
          }
        }
        if (jobArr.length > 0) {
          const str = this.isPretrialReview ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
          const h = this.$createElement
          const content = h('div', null, [
            h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
          ])
          this.$alert(content, str)
          return
        }

        this.opVerifyFrameDialog.batchPassAudit = jobLists.length > 1
        this.opVerifyFrameDialog.job = jobLists[0]
        this.opVerifyFrameDialog.jobList = jobLists
      } else {
        if (this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.acceptCooperateHandler(type, [this.selectedJob.uuid])
          return
        }
        this.opVerifyFrameDialog.batchPassAudit = false
        this.opVerifyFrameDialog.job = this.selectedJob
        const jobLists = []
        jobLists.push(this.selectedJob)
        this.opVerifyFrameDialog.jobList = jobLists
      }

      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    },
    async acceptSubmitCallBack(result) {
      this.batchJobList = []
      this.opVerifyFrameDialog.result = result
      if (this.opVerifyFrameDialog.jobList.length === 1) {
        // this.copySCNotifyToDoc() 放后端进行同步
        this.batchJobList.push(this.opVerifyFrameDialog.job)
      } else {
        // this.copySCNotifyToDoc2(this.opVerifyFrameDialog.jobList) // 放后端进行同步
        // 信控数据校验
        this.batchJobList = this.opVerifyFrameDialog.jobList
      }
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
      // 判断是否开启验证规则
      if (this.useCheckRule) {
        const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
        const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, this.lob)
        if (hasCheckRule) {
          this.batchCheckingWindow.jobs = this.batchJobList
          if (this.allowPartialCheckPass) {
            this.checkingManager(this.batchJobList, checkNode, callBack, null, true, result)
          } else {
            this.checkingManager(this.batchJobList, checkNode, callBack, null, false, result)
          }
        } else {
          callBack()
        }
      } else {
        callBack()
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    async batchAudit() {
      // 订舱预审-审核通过类型1、save2 2、approved2 3、batchUpdateJobs 4、batchApproved
      let verifyType = 0 // 以下接口统一放在后端区分了
      if (this.batchJobList.length === 1) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 1
          // _job.save2(updateJobSuccessResultHandler, failureHandler)
        } else {
          verifyType = 2
          // _job.approved2(saveJobResultHandler, failureHandler)
        }
      }
      if (verifyType === 0) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 3
          // Job.batchUpdateJobs(batchJobList, batchUpdateJobSuccessResultHandler, failureHandler)
        } else {
          verifyType = 4
          // Job.batchApproved(batchJobList, batchSaveJobResultHandler, failureHandler)
        }
      }
      const result = this.opVerifyFrameDialog.result
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      if (result) {
        result.jobKeys = jobKeys
        result.verifyType = this.opVerifyFrameDialog.verifyType = verifyType
        result.jobState = 0
        result.preverifyState = 2
      }
      this.loading = getLoading()
      if (this.isHc && this.isTrunkLineApprove) {
        await updateInquiryJobState(this.selectedJob.jobUuid, 2, 1).then(res => {
          this.selectedJob.trunkLineApproveStatus = 1
        })
      }
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      if (res && res.data) Object.assign(this.opVerifyFrameDialog.job, res.data)
      const verifyType = this.opVerifyFrameDialog.verifyType
      switch (verifyType) {
        case 1:
        case 2:
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          if (this.opVerifyFrameDialog.type === 1) { // 详情审核通过
            this.$emit('refresh', this.opVerifyFrameDialog.job)
          } else {
            this.reloadFunc()
          }
          break
        case 3:
        case 4:
          if (res.data !== '') {
            this.$message.warning(this.$t('SeaExport.WaitBookingVerifyBatch'))
          } else {
            this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
            this.reloadFunc()
          }
          break
        default:
          break
      }
    },
    // 拒绝 0 列表 1 详情
    rejectHandler(type) {
      this.rejectWindow.type = type
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      // 协作业务不支持批量拒绝
      if (jobs.length > 1) {
        for (const job of jobs) {
          if (this.isCooperate(job.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CollabBatchRejectError', [job.jobNo]))
            return
          }
        }
      }
      let rejectCallBack = this.rejectCallBackHandler
      if (jobs.length === 1) {
        const job = jobs[0]
        if (this.isCooperate(job.cooperateStatus)) {
          rejectCallBack = this.rejectCooperateCallBackHandler
        }
      }
      this.rejectWindow.jobNo = this.selectedJob ? this.selectedJob.jobNo : ''
      this.rejectWindow.jobList = jobs
      this.rejectWindow.rejectCallBack = rejectCallBack
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      this.loading = getLoading()
      batchPreVerifyReject({ 'jobKey': jobKeys, 'remark': remark, 'preverifyState': 3 }).then(res => this.preVerifyRejectResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    preVerifyRejectResultHandler(res) {
      this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      this.toQuery()
      this.selectedJob = null
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
    },
    // 复核通过
    btVerifyReviewThroughHandler(type) {
      if (type === 0) {
        // 列表批量复核
        const jobLists = this.readSelectedRows()
        if (!jobLists || jobLists.length <= 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJob'))
          return
        }
        if (jobLists.length > 50) {
          this.$message.warning(this.$t('SeaExport.CheckBatchReview'))
          return
        }
        const jobNos = []
        for (const seaJob of jobLists) {
          if (this.isCooperate(seaJob.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
            return
          }
          if (!(parseInt(seaJob.jobState) === -1 && parseInt(seaJob.preverifyState) === 2)) {
            jobNos.push(seaJob.jobNo)
          }
        }
        if (jobNos.length > 0) {
          const h = this.$createElement
          const content = h('div', null, [
            h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
          ])
          this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
          return
        }
        const jobKeys = Array.from(jobLists, p => p.uuid)
        const result = {}
        result.jobKeys = jobKeys
        result.verifyType = 6
        result.jobState = 0
        result.preverifyState = 5
        this.loading = getLoading()
        approved(result, this.$store.getters.currentOfficeId).then(res => {
          this.$message.success(this.$t('SeaExport.BatchReviewSuccess'))
          this.reloadFunc()
        }).finally(() => {
          this.loading.close()
        })
        // 放在后端处理
        // for(const i:int=0;i<jobLists.length;i++){
        //   const seaJob:SeaExportJob = jobLists.getItemAt(i) as SeaExportJob;
        //   seaJob.jobState = 0;
        //   seaJob.preverifyState = 5;
        // }
        // Job.batchApproved(jobLists,batchReviewThroughResultHandler, failureHandler);
      } else {
        if (this.isCooperate(this.selectedJob.cooperateStatus)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
          return
        }
        // 详情单个复核
        const result = {}
        result.jobKeys = [this.selectedJob.uuid]
        result.verifyType = 5
        result.jobState = 0
        result.preverifyState = 5
        this.loading = getLoading()
        approved(result, this.$store.getters.currentOfficeId).then(res => {
          Object.assign(this.selectedJob, res.data)
          this.$message.success(this.$t('SeaExport.ReviewSuccess'))
          this.$emit('refresh', this.selectedJob)
        }).finally(() => {
          this.loading.close()
        })
        // _job.jobState = 0;
        // _job.preverifyState = 5;
        // _job.approved2(reviewThroughResultHandler, failureHandler);
      }
    },
    // 复核拒绝
    btVerifyReviewRefusalHandler(type) {
      // _job.preverifyState = 6;
      // _job.save2(verifyReviewRefusalResultHandler, failureHandler);
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (this.isCooperate(this.selectedJob.cooperateStatus)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
        return
      }
      this.loading = getLoading()
      preVerifyReject(this.selectedJob.uuid, '', 6).then(res => {
        if (res && res.data) Object.assign(this.selectedJob, res.data)
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        if (type === 1) { // 详情审核通过
          this.$emit('refresh', this.selectedJob)
        } else {
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复制舱位
    cloneCabinHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.cabinDuplicateForm.dialogVisible = true
    },
    // 舱位回填
    cabinBackFillHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.cabinBackFillWindow.job = this.selectedJob
      this.cabinBackFillWindow.visible = true
    },
    reloadFunc() {
      this.toQuery()
      this.selectedJob = null
      this.updateControlsState()
      this.gridApi.clearFocusedCell()
    },
    // 编辑
    async toEdit() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      const row = this.selectedJob
      if (this.viewJobNoSet.has(row.jobNo)) {
        this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: row.jobNo }, params: { action: 'edit' }})
        return
      }
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: row.jobNo }, params: { rowData: [...this.rowData], action: 'edit' }})
      } else {
        row.version = 0 // 以便于从数据库中加载Job数据
        this.$emit('edit', row)
      }
    },
    // 生成业务
    generateBusinessHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (!this.selectedJob.opDepartment || this.selectedJob.opDepartment === 0) {
        this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
        return
      }
      this.$confirm(this.$t('SeaExport.GenerateBusinessTips'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // _job.cabinState = 5;
        // var list:ArrayCollection = new ArrayCollection();
        // list.addItem(_job);
        // acceptSubmitCallBack(list);

        this.opVerifyFrameDialog.job = this.selectedJob
        const jobLists = []
        jobLists.push(this.selectedJob)
        this.opVerifyFrameDialog.jobList = jobLists
        const result = { cabinState: 5 }
        this.acceptSubmitCallBack(result)
      })
    },
    // 退舱
    returnCabinHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.$confirm(this.$t('SeaExport.ReturnedShipping'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // _job.cabinState = 6;
        // _job.save2(returnCabinResultHandler, failureHandler);
        this.loading = getLoading()
        preVerifyReject(this.selectedJob.uuid, '', 7).then(res => {
          if (res && res.data) Object.assign(this.selectedJob, res.data)
          this.$message.success(this.$t('SeaExport.ReturnedShippingSuccess'))
          this.toQuery()
          this.selectedJob = null
          this.updateControlsState()
          this.gridApi.clearFocusedCell()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 复制
    copyJobHandler() {
      if (!this.selectedJob) {
        this.$message.info(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.selectedJob)
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 批量打印
    onBatchPrint() {
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // TemplateSelectorWin.getInstance().showThisWin(new SeaExportJob(), "JOBLIST", {"JOB_UUID":uids,"LOB":"SE"}, this);
        this.templateSelectorDialog.ctx = new SeaExportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'JOBLIST'
        this.templateSelectorDialog.data = { 'JOB_UUID': jobKeys, 'LOB': 'SE' }
        this.templateSelectorDialog.visible = true
      }
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false, newJob = null) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.newJob = newJob
        this.batchCheckingWindow.visible = true
      }
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 复制舱位保存
    cabinDuplicateSubmit(cabinList) {
      if (cabinList) {
        this.loading = getLoading()
        // this.selectedJob.cabinState = 1 // 将舱位状态置为未开始订舱（初始状态）[直接在后端处理了]
        cloneCabin(cabinList, this.selectedJob.uuid).then(res => {
          const newJobNoStr = res.data
          this.$message.success(this.$t('SeaExport.CabinCopySuccess') + newJobNoStr)
          this.cabinDuplicateForm.dialogVisible = false
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 根据船名查询航次
    onVesselSelectionChange(obj) {
      this.transshipDialog[obj.key] = obj.value
      this.transshipDialog.txtVoyage = ''
      if (obj.value) {
        this.transshipDialog.txtVesselIMO = obj.imoCode
        getVoyagesByVesselId(obj.vesselId).then(res => {
          this.transshipDialog.voyages = res.data
        })
      } else {
        this.transshipDialog.txtVesselIMO = ''
        this.transshipDialog.voyages = []
      }
    },
    // 批量转船
    batchVesselHandler() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.toInitClearCheckBox()
      this.toInitTransshipDialog()
      for (const item of rows) {
        if (Number(item.jobState) === Number(SystemConstants.PENDING)) {
          this.transshipDialog.jobKeys.push(item.uuid)
          this.transshipDialog.selectedJobs.push(item)
        }
      }

      const jobs = this.transshipDialog.selectedJobs
      if (jobs.length > 0) {
        let flag = true
        // 判断在订舱性质是否在同一条船,是否是同一个航次
        const bookingTerm = jobs[0].bookingTerm
        const voyageFlight = jobs[0].voyageFlight || ''
        const vessel = jobs[0].vessel || ''
        for (const seaJob of jobs) {
          if (seaJob.voyageFlight !== voyageFlight || seaJob.vessel !== vessel) {
            this.$message.info(this.$t('Message.TheSelectedDocumentIsNotTheSameVoyage'))
            flag = false
            return
          }
          // CARGO-55713 批量转船去除对业务约价性质一致性的校验
          // if (this.editVessel === 2 && seaJob.bookingTerm !== bookingTerm) {
          //   this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheBooking'))
          //   flag = false
          //   return
          // }
        }
        if (flag) {
          this.transshipDialog.visible = true
          // 如果分公司是上海且订舱性质是自订舱,只能选择，其他都是手输入的。
          if (this.editVessel === 3 || (this.editVessel === 2 && bookingTerm === BookingTerm.OS_BOOKING_TYPE.code)) {
            this.transshipDialog.isDBFlag = false
          } else {
            this.transshipDialog.isDBFlag = true
          }
          this.transshipDialog._isVoyages = parseInt(cache.config.get('EditVoyageMode')) === 1
          this.transshipDialog._fmVerify = true
        }
      } else {
        this.$message.warning(this.$t('SeaExport.AllNotToVerifyStatus'))
      }
    },
    // 批量转船点击确定
    transShipClickHandler() {
      if (!this.checkDb()) return
      const jobs = this.transshipDialog.selectedJobs
      if (jobs && jobs.length > 0) {
        const isDBFlag = this.transshipDialog.isDBFlag
        const obj = {}
        obj.jobKeys = this.transshipDialog.jobKeys
        if (!isDBFlag) {
          if (this.transshipDialog.txtVessel) {
            obj.vessel = this.transshipDialog.txtVessel
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
            }
          }
          if (this.transshipDialog.txtVoyage) {
            obj.voyage = this.transshipDialog.txtVoyage
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
            }
          }
        } else {
          if (this.transshipDialog.txtVessel_1 !== '') {
            obj.vessel = this.transshipDialog.txtVessel_1
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
            }
          }
          if (this.transshipDialog.txtVoyage_1 !== '') {
            obj.voyage = this.transshipDialog.txtVoyage_1
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
            }
          }
        }
        if (this.transshipDialog.txtVesselIMO !== '') {
          obj.imo = this.transshipDialog.txtVesselIMO
        } else {
          if (this.clearCheckBox.imo) {
            obj.imo = ''
          }
        }
        const carrierId = this.transshipDialog.txtCarrierId
        if (carrierId !== '' && carrierId > 0) {
          obj.carrierId = carrierId
        } else {
          if (this.clearCheckBox.carrierId) {
            obj.carrierId = 0
          }
        }
        if (this.transshipDialog.dfETD) {
          obj.etd = this.transshipDialog.dfETD
        }
        const bookingAgent = this.transshipDialog.txtBookingAgent
        if (bookingAgent !== '' && bookingAgent > 0) {
          obj.bookingAgent = bookingAgent
        } else {
          if (this.clearCheckBox.bookingAgent) {
            obj.bookingAgent = 0
          }
        }
        this.transshipDialog.transship = obj
        obj.syncPod = Number(cache.config.get('SyncPOD')) === 1
        obj.currentOfficeId = this.$store.getters.currentOfficeId
        batchTransship(obj).then(res => this.batchTransshipResult(res))
      }
    },
    // 订舱预审下 船名、航次、船公司为必填项
    checkDb() {
      if (!this.transshipDialog._fmVerify) return true
      let vessel = '' // 船名
      let voyage = '' // 航次
      if (!this.transshipDialog.isDBFlag) {
        vessel = this.transshipDialog.txtVessel
      } else {
        vessel = this.transshipDialog.txtVessel_1
      }
      if (!this.transshipDialog._isVoyages) {
        voyage = this.transshipDialog.txtVoyage
      } else {
        voyage = this.transshipDialog.txtVoyage_1
      }
      // 船公司
      const carrierId = this.transshipDialog.txtCarrierId
      if (!vessel && !this.clearCheckBox.vessel) {
        this.$message.warning(this.$t('SeaExport.nameOfVesselCannotBeEmpty'))
        return false
      }
      if (!voyage && !this.clearCheckBox.voyage) {
        this.$message.warning(this.$t('SeaExport.voyageNumberCannotBeEmpty'))
        return false
      }
      if ((!carrierId || carrierId === 0) && !this.clearCheckBox.carrierId) {
        this.$message.warning(this.$t('SeaExport.shippingCompanyCannotBeEmpty'))
        return false
      }
      return true
    },
    // 初始化 批量转船对话框数据
    toInitTransshipDialog() {
      if (!this.transshipDialog) return
      for (const key in this.transshipDialog) {
        if (key === '_fmVerify') {
          this.transshipDialog[key] = false
          continue
        }
        if (key === '_isVoyages' || key === 'isDBFlag') {
          this.transshipDialog[key] = true
          continue
        }
        if (key === 'jobKeys' || key === 'selectedJobs') {
          this.transshipDialog[key] = []
          continue
        }
        if (key === 'transship') {
          this.transshipDialog[key] = {}
          continue
        }
        this.transshipDialog[key] = ''
      }
    },
    // 批量转船 处理返回结果
    batchTransshipResult(res) {
      // const list = res.data
      this.$confirm(this.$t('Message.BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'success'
      }).then(() => {
        this.batchTransshipFresh()
        this.transshipDialog.visible = false
      }).catch(() => {
        this.batchTransshipFresh()
      })
    },
    // 批量转船 刷新
    batchTransshipFresh() {
      const objJobKey = {}
      const jobKeys = this.transshipDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      const transship = this.transshipDialog.transship
      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          if (transship.hasOwnProperty('vessel')) {
            seaJob.vessel = transship.vessel
          }
          if (transship.hasOwnProperty('voyage')) {
            seaJob.voyageFlight = transship.voyage
          }
          if (transship.hasOwnProperty('carrierId')) {
            seaJob.carrierId = transship.carrierId
          }
          if (transship.hasOwnProperty('etd')) {
            seaJob.etd = transship.etd
          }
          if (transship.hasOwnProperty('bookingAgent')) {
            seaJob.bookingAgent = transship.bookingAgent
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 是否协作状态
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type, cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedJob.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedJob.cooperateBranchId,
        opId: this.selectedJob.cooperateOpId,
        csrId: this.selectedJob.cooperateCsrId,
        overseaOp: this.selectedJob.cooperateOverseaOp,
        dcId: this.selectedJob.cooperateDcId,
        planner: this.selectedJob.cooperatePlanner,
        sales: this.selectedJob.cooperateSales,
        cargoSalesId: this.selectedJob.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedJob.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedJob.cooperateUserDefinedRoleId2,
        businessType: this.selectedJob.cooperateBusinessTypeCode ? this.selectedJob.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.config = cache.config
      this.cooperationVerifyDialog.job = null
      const seaJob = {
        lob: this.selectedJob.lob,
        bookingAgent: this.selectedJob.bookingAgent,
        scNo: this.selectedJob.scNo,
        carrierAgentId: this.selectedJob.carrierAgentId,
        carrierId: this.selectedJob.carrierId
      }
      this.cooperationVerifyDialog.job = seaJob
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      const seaJob = this.cooperationVerifyDialog.job
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark, bookingAgent: seaJob.bookingAgent, scNo: seaJob.scNo, carrierAgentId: seaJob.carrierAgentId, carrierId: seaJob.carrierId }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedJob.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.reloadFunc()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toInitClearCheckBox() {
      this.clearCheckBox.vessel = false
      this.clearCheckBox.voyage = false
      this.clearCheckBox.carrierId = false
      this.clearCheckBox.bookingAgent = false
      this.clearCheckBox.imo = false
    },
    clearCheckBoxChange(key = '') {
      switch (key) {
        case 'vessel':
          if (this.clearCheckBox.vessel) {
            this.transshipDialog.txtVessel = ''
            this.transshipDialog.txtVessel_1 = ''
          }
          break
        case 'carrierId':
          if (this.clearCheckBox.carrierId) {
            this.transshipDialog.txtCarrierId = 0
          }
          break
        case 'bookingAgent':
          if (this.clearCheckBox.bookingAgent) {
            this.transshipDialog.txtBookingAgent = 0
          }
          break
        case 'imo':
          if (this.clearCheckBox.imo) {
            this.transshipDialog.txtVesselIMO = ''
          }
          break
        case 'voyage':
          if (this.clearCheckBox.voyage) {
            this.transshipDialog.txtVoyage = ''
            this.transshipDialog.txtVoyage_1 = ''
          }
          break
        default:
      }
    },
    setOperationDateQueryData() {
      console.log('主应用发送OperationDateQuery:', this.operationDateQuery)
      microApp.forceSetData('child-operation-date-query-bookingverify', this.operationDateQuery)
    },
    operationDateQueryDataChange(e) {
      console.log('主应用获取OperationDateQuery:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateQueryData()
        } else {
          this.operationDateQuerySearch = e.detail.data.searchItem
          this.operationDateQueryColumn = e.detail.data.columnItem
        }
      }
    },
    // 港前、干线、尾程审核
    priceAuditHandle() {
      switch (this.priceAuditCommand) {
        case this.$t('CargoMsg.Cargo_preportAudit'):
          this.toPriceAudit(1)
          break
        case this.$t('CargoMsg.Cargo_TrunkLineAudit'):
          this.toPriceAudit(2)
          break
        case this.$t('CargoMsg.Cargo_TailEndAudit'):
          this.toPriceAudit(3)
          break
      }
    },
    // 港前、干线、尾程审核
    async toPriceAudit(type) {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      const row = this.selectedJob
      const userId = this.$store.getters.userId // 当前用户
      const isAdmin = this.$store.getters.isAdmin
      if (type === 1) {
        const preFlag = !row.prePortPlanner
        if (preFlag) { // 港前价格是否开启
          this.$message.warning(this.$t('CargoMsg.Cargo_NoItems_NoAudit', [this.$t('CargoMsg.Cargo_PrePortBusinessLeader')]))
          return
        }
        if (row.prePortApproveStatus === 1 || row.prePortApproveStatus === 2) { // 已审核或已拒绝
          this.$message.warning(this.$t('CargoMsg.Cargo_Audited_NoNeedAudit'))
          return
        }
        if (row.prePortPlanner !== userId && !isAdmin) { // 不是审核人
          this.$message.warning(this.$t('CargoMsg.Cargo_NoAuthorityReview'))
          return
        }
        await updateInquiryJobState(row.jobUuid, type, 1).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          this.toQuery()
          this.gridApi.clearFocusedCell()
        })
      } else if (type === 2) {
        const preFlag = !row.planner
        if (preFlag) { // 干线价格是否开启
          this.$message.warning(this.$t('CargoMsg.Cargo_NoItems_NoAudit', [this.$t('CargoMsg.Cargo_AirlinePerson')]))
          return
        }
        if (row.trunkLineApproveStatus === 1 || row.trunkLineApproveStatus === 2) { // 已审核或已拒绝
          this.$message.warning(this.$t('CargoMsg.Cargo_Audited_NoNeedAudit'))
          return
        }
        if (row.planner !== userId && !isAdmin) { // 不是审核人
          this.$message.warning(this.$t('CargoMsg.Cargo_NoAuthorityReview'))
          return
        }
        this.isTrunkLineApprove = true
        this.inquiryPassAudit(row)
      } else if (type === 3) {
        const preFlag = !row.lastMilePlanner
        if (preFlag) { // 尾程价格是否开启
          this.$message.warning(this.$t('CargoMsg.Cargo_NoItems_NoAudit', [this.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
          return
        }
        if (row.lastMileApproveStatus === 1 || row.lastMileApproveStatus === 2) { // 已审核或已拒绝
          this.$message.warning(this.$t('CargoMsg.Cargo_Audited_NoNeedAudit'))
          return
        }
        if (row.lastMilePlanner !== userId && !isAdmin) { // 不是审核人
          this.$message.warning(this.$t('CargoMsg.Cargo_NoAuthorityReview'))
          return
        }
        // 更新尾程审核状态
        await updateInquiryJobState(row.jobUuid, type, 1).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          this.toQuery()
          this.gridApi.clearFocusedCell()
        })
      }
    },
    inquiryPassAudit(row) {
      const jobLists = []
      jobLists.push(row)
      this.opVerifyFrameDialog.type = 0
      this.opVerifyFrameDialog.batchPassAudit = false
      this.opVerifyFrameDialog.job = row
      this.opVerifyFrameDialog.jobList = jobLists
      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
}
</style>
